/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_b64_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is Base64 encryption, or is it secure?`)
};

const es_b64_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Es Base64 una encriptación, o es seguro?`)
};

const de_b64_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist Base64 eine Verschlüsselung oder ist es sicher?`)
};

const nl_b64_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is Base64 encryptie, of is het veilig?`)
};

const fr_b64_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base64 est-il du chiffrement, ou est-il sûr ?`)
};

const it_b64_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base64 è crittografia, o è sicuro?`)
};

const pt_br2_b64_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base64 é criptografia, ou é seguro?`)
};

const pt_b64_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base64 é encriptação, ou é seguro?`)
};

const ja_b64_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base64は暗号化ですか、それとも安全ですか?`)
};

const zh_b64_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base64 是加密方式吗？它安全吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const b64_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.b64_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("b64_faq4_q", locale)
	if (locale === "en") return en_b64_faq4_q(inputs)
	if (locale === "es") return es_b64_faq4_q(inputs)
	if (locale === "de") return de_b64_faq4_q(inputs)
	if (locale === "nl") return nl_b64_faq4_q(inputs)
	if (locale === "fr") return fr_b64_faq4_q(inputs)
	if (locale === "it") return it_b64_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_b64_faq4_q(inputs)
	if (locale === "pt") return pt_b64_faq4_q(inputs)
	if (locale === "ja") return ja_b64_faq4_q(inputs)
	return zh_b64_faq4_q(inputs)
};